module.exports = __webpack_public_path__ + "trash.png";